export default "__VITE_ASSET__DK$gWil7__";